/* eslint-disable import/order */
import { MenuIdStatusPageManage } from '@jira/navigation-apps__constants/src/MenuIdStatusPageManage.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStatusPageConfigurationRoute } from '@jira/router-routes__communications-routes/src/communicationsStatusPageConfigurationRoute.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { StatusPageConfigurationPageEntryPoint } from './ui/status-page-configuration/StatusPageConfigurationPageEntryPoint.tsx';

export const communicationsStatusPageConfigurationRouteEntry: Route = createEntry(
	communicationsStatusPageConfigurationRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MenuIdStatusPageManage,
		},

		entryPoint: () => {
			return fg('communications_status_page_manage_platform')
				? StatusPageConfigurationPageEntryPoint
				: undefined;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
